export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-evernote-fc4cbae9b22b71fd92030a89381ab530.svg";